import React, { useState, useCallback, useEffect } from "react";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Text from "../../../components/Common/Text";
import Colors from "../../../themes/Colors";
import { validarCorreo } from "../utils/ValidationUtils";

const ModalCorreoValidacion = ({
  isOpen,
  onClose,
  onConfirm,
  correoActual,
  telefono,
}) => {
  const [correoEnvio, setCorreoEnvio] = useState("");
  const [correoEnvioError, setCorreoEnvioError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCorreoEnvio("");
      setCorreoEnvioError("");
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const handleChangeCorreoEnvio = useCallback((value) => {
    setCorreoEnvio(value);
    if (correoEnvioError) {
      const error = validarCorreo(value);
      setCorreoEnvioError(error);
    }
  }, [correoEnvioError]);

  const handleConfirm = useCallback(async () => {
    const error = validarCorreo(correoEnvio);
    if (error) {
      setCorreoEnvioError(error);
      return;
    }

    try {
      setIsSubmitting(true);
      await onConfirm(correoEnvio);
    } finally {
      setIsSubmitting(false);
    }
  }, [correoEnvio, onConfirm]);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <CustomModal isOpen={isOpen} onClose={handleCancel} maxWidth="600px">
      <Section flexDirection="column" padding="20px">
        <Text size="20px" weight="bold">
          Correo para envío de validación
        </Text>

        <CustomSeparator height={"20px"} />

        <Section flexDirection="column" width="100%">
          <CustomInput
            type="email"
            label="Correo registrado del PSS"
            value={correoActual || "no disponible"}
            disabled={true}
            width="100%"
          />

          <CustomSeparator height={"15px"} />

          <CustomInput
            type="text"
            label="Teléfono"
            value={telefono || "N/A"}
            disabled={true}
            width="100%"
          />

          <CustomSeparator height={"15px"} />

          <CustomInput
            type="email"
            label="Correo para esta validación"
            value={correoEnvio}
            onChange={handleChangeCorreoEnvio}
            width="100%"
            required={true}
          />

          {correoEnvioError && (
            <>
              <CustomSeparator height={"10px"} />
              <Text size="12px" color={Colors.red || "red"}>
                {correoEnvioError}
              </Text>
            </>
          )}
        </Section>

        <CustomSeparator height={"20px"} />

        <Section
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <CustomButton
            label="Cancelar"
            onClick={handleCancel}
            disabled={isSubmitting}
            width="120px"
            height="40px"
          />
          <CustomButton
            label="Confirmar envío"
            onClick={handleConfirm}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            width="150px"
            height="40px"
          />
        </Section>
      </Section>
    </CustomModal>
  );
};

export default ModalCorreoValidacion;


